import Banner from 'components/Banner';
import PanelSection from 'components/PanelSection';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MixOrderIssues: FunctionComponent<Props> = ({
    className = '',
    describeIssueCode,
    issues,
    severityToBannerVariant,
    testId = TEST_ID,
    title
}) => (
    <PanelSection className={`${styles.mixOrderIssues} ${className}`} testId={testId} text={title}>
        {issues.map(issue => (
            <Banner
                icon='warning'
                key={`${issue.chemicalId}-${issue.code}`}
                metadata={describeIssueCode(issue.code)}
                text={issue.message}
                variant={severityToBannerVariant[issue.severity]}
            />
        ))}
    </PanelSection>
);

export default MixOrderIssues;
